(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD',
  }).format(Number(cents) / 100);
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const announce = (message) => {
    const status = document.querySelector('[data-site-status]');
    if (status) { status.textContent = ''; requestAnimationFrame(() => { status.textContent = message; }); }
  };
  const request = async (path, options = {}) => {
    const response = await fetch(root + path, { ...options, headers: { Accept: 'application/json', ...options.headers } });
    let data;
    try { data = await response.json(); } catch { throw new Error('Unable to connect. Please try again.'); }
    if (!response.ok) throw new Error(data.description || data.message || 'Please try again.');
    return data;
  };
  let activeDrawer = null;
  let returnFocus = null;
  const drawers = {
    menu: document.querySelector('.mobile-menu-drawer'),
    cart: document.querySelector('[data-cart-drawer]'),
    filters: document.querySelector('.filter-drawer'),
  };
  Object.values(drawers).filter(Boolean).forEach((drawer) => { drawer.inert = true; });
  function closeDrawer() {
    if (!activeDrawer) return;
    const drawer = drawers[activeDrawer];
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    document.body.classList.remove(activeDrawer + '-open');
    activeDrawer = null;
    returnFocus?.focus();
  }
  function openDrawer(name, trigger) {
    if (!drawers[name]) return;
    closeDrawer();
    activeDrawer = name;
    returnFocus = trigger || document.activeElement;
    drawers[name].inert = false;
    drawers[name].setAttribute('aria-hidden', 'false');
    document.body.classList.add(name + '-open');
    drawers[name].querySelector('button, a, input')?.focus();
  }
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
    if (event.key !== 'Tab' || !activeDrawer) return;
    const nodes = [...drawers[activeDrawer].querySelectorAll('button, a, input, select, [tabindex="0"]')]
      .filter((node) => !node.disabled && node.getClientRects().length);
    const first = nodes[0]; const last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  let cartBusy = false;
  function cartStatus(message) {
    const node = document.querySelector('[data-cart-status]');
    if (node) { node.hidden = !message; node.textContent = message; }
  }
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    const titleCount = document.querySelector('[data-cart-title-count]');
    if (titleCount) titleCount.textContent = cart.item_count;
    const items = document.querySelector('[data-cart-items]');
    if (!items) return;
    document.querySelector('[data-cart-filled]').hidden = !cart.item_count;
    document.querySelector('[data-cart-empty]').hidden = !!cart.item_count;
    document.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);
    const drawer = document.querySelector('[data-cart-drawer]');
    const shippingMessage = document.querySelector('[data-free-shipping-message]');
    const shippingProgress = document.querySelector('[data-free-shipping-progress]');
    const threshold = Number(drawer?.dataset.freeShippingThreshold || 0);
    if (shippingMessage && shippingProgress) {
      const remaining = Math.max(threshold - cart.total_price, 0);
      const percent = threshold > 0 ? Math.min((cart.total_price / threshold) * 100, 100) : 100;
      shippingMessage.replaceChildren();
      if (remaining > 0) {
        shippingMessage.append('Spend ', el('strong', '', money(remaining)), ' more for ', el('strong', '', 'FREE'), ' delivery');
      } else {
        shippingMessage.append(el('strong', '', 'You have unlocked FREE delivery'));
      }
      shippingProgress.style.width = `${percent}%`;
    }
    items.replaceChildren();
    cart.items.forEach((item) => {
      const line = el('div', 'cart-line');
      const link = el('a', 'cart-line__image'); link.href = item.url;
      if (item.image) { const img = el('img'); img.src = item.image; img.alt = item.product_title; img.width = 96; img.height = 128; link.append(img); }
      const copy = el('div', 'cart-line__details');
      const title = el('a', 'cart-line__title', item.product_title); title.href = item.url;
      copy.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') copy.append(el('p', '', item.variant_title));
      copy.append(el('strong', '', money(item.final_line_price)));
      const quantity = el('div', 'cart-line__quantity');
      const decrease = el('button', '', '\u2212'); decrease.type = 'button';
      decrease.setAttribute('aria-label', `Decrease quantity of ${item.product_title}`);
      decrease.addEventListener('click', () => changeQuantity(item.key, item.quantity - 1));
      const count = el('span', '', String(item.quantity));
      const increase = el('button', '', '+'); increase.type = 'button';
      increase.setAttribute('aria-label', `Increase quantity of ${item.product_title}`);
      increase.addEventListener('click', () => changeQuantity(item.key, item.quantity + 1));
      quantity.append(decrease, count, increase);
      copy.append(quantity);
      const remove = el('button', 'cart-line__remove', '\u00d7'); remove.type = 'button';
      remove.setAttribute('aria-label', `Remove ${item.product_title}`);
      remove.addEventListener('click', () => changeQuantity(item.key, 0));
      line.append(link, copy, remove); items.append(line);
    });
  }
  async function refreshCart() { const cart = await request('cart.js'); renderCart(cart); return cart; }
  async function changeQuantity(key, quantity) {
    if (cartBusy) return;
    cartBusy = true; cartStatus('Updating your bag...');
    const panel = document.querySelector('[data-cart-items]');
    panel.querySelectorAll('button').forEach((button) => { button.disabled = true; });
    try {
      renderCart(await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) }));
      cartStatus('Your bag has been updated.');
      drawers.cart.querySelector('[data-cart-close][type="button"]')?.focus();
    } catch (error) { cartStatus(error.message); }
    finally { cartBusy = false; panel.querySelectorAll('button').forEach((button) => { button.disabled = false; }); }
  }
  document.addEventListener('click', (event) => {
    for (const [name, prefix] of [['menu', 'menu'], ['cart', 'cart'], ['filters', 'drawer']]) {
      const open = event.target.closest(`[data-${prefix}-open]`);
      if (open) {
        event.preventDefault(); openDrawer(name, open);
        if (name === 'cart') { cartStatus(''); refreshCart().catch((error) => cartStatus(error.message)); }
      }
      if (event.target.closest(`[data-${prefix}-close]`)) closeDrawer();
    }
  });

  document.querySelectorAll('[data-cart-recommendation-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (cartBusy) return;
      const button = form.querySelector('button[type="submit"]');
      cartBusy = true;
      if (button) { button.disabled = true; button.textContent = 'Adding...'; }
      try {
        await request('cart/add.js', { method: 'POST', body: new FormData(form) });
        await refreshCart();
        cartStatus('Added to your bag.');
        openDrawer('cart', button);
        announce('Added to your bag.');
      } catch (error) {
        cartStatus(error.message);
      } finally {
        cartBusy = false;
        if (button) { button.disabled = false; button.textContent = 'Add to Bag'; }
      }
    });
  });

  const thumbs = [...document.querySelectorAll('[data-product-thumb]')];
  const mainImage = document.querySelector('[data-product-main-image]');
  const zoom = document.querySelector('[data-product-zoom]');
  function showImage(thumb) {
    if (!thumb || !mainImage) return;
    mainImage.src = thumb.dataset.productThumb;
    mainImage.alt = thumb.querySelector('img')?.alt || '';
    thumbs.forEach((node) => { node.classList.toggle('is-active', node === thumb); node.setAttribute('aria-current', String(node === thumb)); });
    if (zoom) {
      zoom.querySelector('[data-zoom-image]').src = thumb.dataset.productZoomSrc;
      zoom.querySelector('[data-zoom-image]').alt = mainImage.alt;
      zoom.querySelector('[data-zoom-counter]').textContent = `${thumbs.indexOf(thumb) + 1} / ${thumbs.length}`;
    }
  }
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => showImage(thumb)));
  const stepImage = (step) => showImage(thumbs[(Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active'))) + step + thumbs.length) % thumbs.length]);
  document.querySelector('[data-zoom-open]')?.addEventListener('click', () => {
    showImage(thumbs.find((thumb) => thumb.classList.contains('is-active')) || thumbs[0]);
    zoom.showModal(); document.body.classList.add('zoom-open');
  });
  if (zoom) {
    zoom.querySelector('[data-zoom-close]').addEventListener('click', () => zoom.close());
    zoom.querySelectorAll('[data-zoom-step]').forEach((button) => button.addEventListener('click', () => stepImage(Number(button.dataset.zoomStep))));
    zoom.addEventListener('keydown', (event) => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); stepImage(event.key === 'ArrowLeft' ? -1 : 1); } });
    zoom.addEventListener('close', () => document.body.classList.remove('zoom-open'));
    zoom.addEventListener('click', (event) => { if (event.target === zoom) zoom.close(); });
  }
  document.querySelector('[data-open-dimensions]')?.addEventListener('click', () => { document.querySelector('#product-dimensions').open = true; });

  const variantJson = document.querySelector('[data-product-variants-json]');
  const productForm = document.querySelector('[data-product-form]');
  if (variantJson && productForm) {
    const variants = JSON.parse(variantJson.textContent || '[]');
    const variantInput = productForm.querySelector('[data-variant-id]');
    const groups = [...productForm.querySelectorAll('[data-product-option]')];
    const buttons = [...document.querySelectorAll('[data-product-submit]')];
    const stickyVariantInput = document.querySelector('[data-sticky-variant-id]');
    const stickyAddButton = document.querySelector('[data-sticky-add]');
    if (stickyAddButton) buttons.push(stickyAddButton);
    const status = document.querySelector('[data-product-status]');
    let variant = variants.find((item) => String(item.id) === variantInput.value);
    let adding = false;
    function syncVariant(updateUrl = false) {
      variantInput.value = variant?.id || '';
      if (stickyVariantInput) stickyVariantInput.value = variant?.id || '';
      document.querySelectorAll('[data-product-price]').forEach((node) => { node.textContent = variant ? money(variant.price) : 'Unavailable'; });
      buttons.forEach((button) => { button.disabled = adding || !variant?.available; button.textContent = adding ? 'Adding...' : !variant ? 'Unavailable' : variant.available ? 'Add to bag' : 'Sold out'; });
      const stickyVariant = document.querySelector('[data-sticky-variant]');
      if (stickyVariant) stickyVariant.textContent = variant?.title === 'Default Title' ? '' : variant?.title || '';
      const code = document.querySelector('[data-product-code]');
      if (code && !code.dataset.staticCode) code.textContent = variant?.sku || '';
      if (variant?.featured_image) {
        const thumb = thumbs.find((node) => Number(node.dataset.mediaId) === variant.featured_image.id);
        if (thumb) showImage(thumb);
        const stickyImage = document.querySelector('[data-sticky-image]');
        if (stickyImage) stickyImage.src = variant.featured_image.src;
      }
      if (updateUrl) {
        const url = new URL(location.href);
        if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
        history.replaceState({}, '', url);
      }
    }
    groups.forEach((group) => group.querySelectorAll('[data-option-value]').forEach((button) => button.addEventListener('click', () => {
      if (adding) return;
      group.querySelectorAll('[data-option-value]').forEach((node) => { node.classList.toggle('is-selected', node === button); node.setAttribute('aria-pressed', String(node === button)); });
      group.querySelector('[data-selected-option]').textContent = button.dataset.optionValue;
      variant = variants.find((item) => groups.every((option) => item.options[Number(option.dataset.optionPosition) - 1] === option.querySelector('.is-selected').dataset.optionValue));
      status.hidden = true; syncVariant(true);
    })));
    syncVariant();
    if (stickyAddButton) stickyAddButton.addEventListener('click', () => productForm.requestSubmit());
    const sticky = document.querySelector('.mobile-sticky-purchase, .mobile-sticky-cart');
    const buyRow = productForm.querySelector('.buy-row');
    if (sticky && 'IntersectionObserver' in window) {
      sticky.hidden = true;
      new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.boundingClientRect.bottom >= 0;
      }, { threshold: [0, 1] }).observe(buyRow);
    }
    productForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (adding || !variant?.available) return;
      adding = true; status.hidden = true; syncVariant();
      groups.forEach((group) => { group.inert = true; });
      let added = false;
      try {
        await request('cart/add.js', { method: 'POST', body: new FormData(productForm) });
        added = true;
        await refreshCart();
        cartStatus('Added to your bag.'); openDrawer('cart', event.submitter); announce('Added to your bag.');
      } catch (error) {
        status.hidden = false;
        status.replaceChildren(document.createTextNode(added ? 'Added to your bag, but the bag could not refresh. ' : error.message + ' '));
        if (added) { const link = el('a', 'text-link', 'View cart'); link.href = root + 'cart'; status.append(link); }
      } finally {
        adding = false; groups.forEach((group) => { group.inert = false; }); syncVariant();
      }
    });
  }

  const wishlistKey = 'oovault-wishlist-v1';
  const readWishlist = () => {
    try { const data = JSON.parse(localStorage.getItem(wishlistKey) || '[]'); return Array.isArray(data) ? [...new Set(data.filter((value) => typeof value === 'string' && /^[a-z0-9-]+$/.test(value)))].slice(0, 100) : []; }
    catch { return []; }
  };
  function syncWishlistButtons() {
    const saved = readWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = saved.includes(button.dataset.productHandle);
      button.setAttribute('aria-pressed', String(active)); button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      const label = button.querySelector('[data-wishlist-label]'); if (label) label.textContent = active ? 'Saved to wishlist' : 'Add to wishlist';
    });
  }
  const wishlist = document.querySelector('[data-wishlist-grid]');
  let wishlistRun = 0;
  async function renderWishlist() {
    if (!wishlist) return;
    const run = ++wishlistRun; const handles = readWishlist();
    const empty = document.querySelector('[data-wishlist-empty]');
    const status = document.querySelector('[data-wishlist-status]');
    wishlist.replaceChildren(); empty.hidden = handles.length > 0;
    status.textContent = handles.length ? 'Loading your saved pieces...' : '';
    for (const handle of handles) {
      let product = null;
      try { product = await request(`products/${encodeURIComponent(handle)}.js`); } catch { /* Keep an unavailable entry removable instead of silently discarding it. */ }
      if (run !== wishlistRun) return;
      const card = document.querySelector('[data-wishlist-card]').content.cloneNode(true);
      const button = card.querySelector('[data-wishlist-toggle]'); button.dataset.productHandle = handle;
      card.querySelector('h3 a').textContent = product?.title || 'Product unavailable';
      card.querySelectorAll('a').forEach((link) => { if (product) link.href = product.url; else link.removeAttribute('href'); });
      const img = card.querySelector('img');
      if (product?.featured_image) { img.src = product.featured_image; img.alt = product.title; } else img.remove();
      card.querySelector('[data-wishlist-price]').textContent = product ? `${product.price_varies ? 'From ' : ''}${money(product.price)}` : 'This piece is currently unavailable.';
      wishlist.append(card); syncWishlistButtons();
    }
    if (run === wishlistRun) status.textContent = `${handles.length} saved ${handles.length === 1 ? 'piece' : 'pieces'}`;
  }
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]'); if (!button) return;
    const handle = button.dataset.productHandle; if (!handle) return;
    const saved = readWishlist(); const active = saved.includes(handle);
    if (!active && saved.length >= 100) { announce('Your wishlist is full. Remove a piece before adding another.'); return; }
    try { localStorage.setItem(wishlistKey, JSON.stringify(active ? saved.filter((value) => value !== handle) : [...saved, handle])); }
    catch { announce('Your browser could not save this piece. Please allow local storage and try again.'); return; }
    syncWishlistButtons(); renderWishlist(); announce(active ? 'Removed from wishlist.' : 'Saved to wishlist.');
  });
  window.addEventListener('storage', (event) => { if (event.key === wishlistKey || event.key === null) { syncWishlistButtons(); renderWishlist(); } });
  syncWishlistButtons(); renderWishlist();
  document.querySelectorAll('[data-sort-select]').forEach((select) => select.addEventListener('change', () => select.form.requestSubmit()));

  function initNewsletterOffers() {
    document.querySelectorAll('[data-newsletter-offer]').forEach((dialog) => {
      if (dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
      dialog.dataset.initialized = 'true';
      const trigger = dialog.parentElement.querySelector('[data-newsletter-show-offer]');
      const code = dialog.querySelector('[data-newsletter-code]');
      const status = dialog.querySelector('[data-newsletter-copy-status]');
      const open = () => {
        if (dialog.open) return;
        closeDrawer();
        status.textContent = '';
        dialog.showModal();
        document.body.classList.add('newsletter-offer-open');
      };
      trigger.hidden = false;
      trigger.addEventListener('click', open);
      dialog.querySelector('[data-newsletter-close]').addEventListener('click', () => dialog.close());
      dialog.querySelector('[data-newsletter-copy]').addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(code.value);
          status.textContent = 'Code copied.';
        } catch {
          code.focus();
          code.select();
          status.textContent = 'Copy the selected code to use at checkout.';
        }
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.body.classList.remove('newsletter-offer-open');
        trigger.focus({ preventScroll: true });
        // Keep a refresh from redisplaying Shopify's previous success response.
        const url = new URL(location.href);
        if (url.searchParams.has('customer_posted')) {
          url.searchParams.delete('customer_posted');
          history.replaceState(history.state, '', url);
        }
      });
      open();
    });
  }
  initNewsletterOffers();
  document.addEventListener('shopify:section:load', initNewsletterOffers);
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector('[data-newsletter-offer][open]')) document.body.classList.remove('newsletter-offer-open');
  });
})();
